module.exports = __webpack_public_path__ + "media/logo-small.abe814cc06cf7383d3769293d27f8895.svg";